









































import { Component, Vue } from 'vue-property-decorator'
import PageHead from '@/components/PageHead.vue'
import { Notify } from '@/helpers/Notify'
import { Helper } from '@/helpers/Helper'
import { Api } from '@/fetch/Api'
import store from '@/store'

@Component({
  components: {
    PageHead,
  },
})
export default class PageEdit extends Vue {
  pageTitle = 'Reset User Password'
  callInProgress = false
  RequestDisabled = false
  password = null
  confirm_password = null

  public async resetUserPassword() {
    this.callInProgress = true
    try {
      await Api.resetUserPassword(this.password, this.confirm_password, Helper.getCurrentDomain())
      this.callInProgress = false
      Notify.create({
        type: 'success',
        title: 'Saved!',
        text: 'Password for therapist user updated.',
      })
    } catch (e) {
      this.callInProgress = false
      Notify.create({
        type: 'error',
        title: 'Something went wrong...',
        text: e,
      })
    }
  }
}
